module.exports = __webpack_public_path__ + "static/2-create-project-2d0cf24902d8feaecb4bbfc60df59ec0.png";